import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { REPORT_TYPES } from '../../constants';
import { PoliciesService, SessionService } from '../../../shared/services';
import { Policies } from '../../../shared/constants';
import { hasReportsOnlyAccess } from 'src/app/shared/validators/access';

@Component({
  selector: 'repository-item',
  templateUrl: './repository-item.component.html',
  styleUrls: ['./repository-item.component.scss']
})
export class RepositoryItemComponent implements OnInit {
  @Input() compact = false;
  @Input() list = false;
  @Input() report: any;
  @Input() showOptions: Boolean|string = true;
  @Output() onDownloadClicked = new EventEmitter();
  @Output() onOptionClicked = new EventEmitter();
  @Input() activeReportType: any;
  REPORT_TYPES = REPORT_TYPES;
  getEntitiesPolicy: string[] = [Policies.GET_ENTITIES];

  // TODO: this is a hack for tp-update canned-demo and should be removed.
  // SessionService can be removed as well
  isTpUpdateCannedDemo: boolean;

  // TODO: Remove me and hoist this outside the component.  Entity detail
  // repository page doesn't use this.
  options: Array<Object> = [{
    name: 'Dashboard',
    value: 'dashboard',
    policies: this.getEntitiesPolicy
  }, {
    name: 'Repository',
    value: 'repository',
    policies: this.getEntitiesPolicy
  }, {
    name: 'Transactions',
    value: 'transactions',
    policies: this.getEntitiesPolicy
  }];

  constructor(private _policiesService: PoliciesService, private _sessionService: SessionService) {
    // TODO: this is a hack for tp-update canned-demo and should be removed.
    // SessionService can be removed as well
    this.isTpUpdateCannedDemo = this._sessionService.getUserRole() === 'tpiqsales' &&
                                this._sessionService.getWorkingContainer().containerId === 5440;
  }

  ngOnInit() {
    this._policiesService.getUserPolicies().subscribe((policies) => {
      this.showOptions = this.showOptions && (this.showOptions !== 'false') &&
        policies.some(policy => policy.policyName.includes(Policies.GET_ENTITIES));
    });
  }

  ngOnChanges() {
  }

  getTruncatedReportName(report, length = 40) {
    return report && report.reportName.length > length - 25 ?
      report.reportName.substr(0, length - 25) + ' ... ' +
      report.reportName.substr(-25) : report.reportName;
  }

  denyAccessDetails() {
    return hasReportsOnlyAccess();
  }
}
